<template>
  <section
    id="octadesk-app-contact"
    class="octadesk-app-contact"
    :class="{ 'kb-card-bottom-offset': kbEnabled && showKbCard }"
  >
    <WidgetHeader v-if="active" class="no-agents" />

    <KbCard v-if="kbEnabled && showKbCard" @cta="handleKbCardCta" />

    <Card v-else class="octadesk-contact--card">
      <div class="text-center kb-contact-container">
        <div v-show="!contactMessageSent" class="octadesk-content-container">
          <p class="not-avaliable-msg">
            <strong>{{ unavailable }}</strong>
          </p>

          <form v-if="hasTicketApp" class="octadesk-form">
            <fieldset class="octadesk-fieldset">
              <label for="Message" :text="$t('contact.message')"></label>

              <textarea
                v-model="message"
                :placeholder="$t('contact.message')"
                required
              ></textarea>
            </fieldset>
          </form>
        </div>

        <div
          v-if="contactMessageSent"
          id="octadesk-success-container"
          class="octadesk-content-container octadesk-success-container"
        >
          <img
            :src="require('@/css/images/check-verde.svg')"
            alt
            style="width: 80px; margin-top: -20px"
          />

          <p v-html="$sanitizeHtml($t('contact.messageSent'))" />

          <button
            :style="`background-color: rgba(${settings.bgColorRGBA}); color: rgba(${settings.fontColorRGBA});`"
            type="button"
            class="button-close"
            @click="newChat"
          >
            {{ $t('contact.buttonBack') }}
          </button>
        </div>

        <button
          v-if="!sending && !contactMessageSent"
          :style="`background-color: rgb(${settings.bgColorRGB}); color: rgba(${settings.fontColorRGBA});`"
          :disabled="!message"
          :class="{ hide: !kbEnabled && !showKbCard && !hasTicketApp }"
          class="octadesk-button octadesk-button__contact"
          @click="send"
        >
          {{ $t('contact.buttonSend') }}
        </button>

        <div v-if="sending" class="sending-loader-height">
          <ScaleLoader
            class="sending-loader"
            :color="`rgba(${settings.bgColorRGBA})`"
            :height="'25px'"
            :width="'6px'"
          ></ScaleLoader>
        </div>
      </div>
    </Card>

    <FooterPoweredBy />
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

  import FooterPoweredBy from '@/app/components/FooterPoweredBy'

  import WidgetHeader from '@/app/components/WidgetHeader'

  import Card from '@/app/components/Card'

  import KbCard from '@/app/components/KbCard'

  export default {
    components: {
      WidgetHeader,
      ScaleLoader,
      FooterPoweredBy,
      Card,
      KbCard
    },
    data() {
      return {
        message: '',
        sending: false,
        showKbCard: false,
        hasTicketApp: false
      }
    },
    computed: {
      ...mapGetters([
        'settings',
        'kbEnabled',
        'contactMessageSent',
        'externalLogin',
        'active',
        'user'
      ]),
      unavailable() {
        if (this.settings && this.settings.messages.unavailable.length) {
          return this.settings.messages.unavailable
        } else {
          return this.$t('contact.title')
        }
      }
    },
    mounted() {
      if (this.kbEnabled) {
        this.showKbCard = true
      }
    },
    async created() {
      await this.setHasTicketApp()
    },
    methods: {
      ...mapActions([
        'createChat',
        'createTicket',
        'setContactMessageSent',
        'newConversation',
        'verifyHasTicketApp'
      ]),
      newChat() {
        this.setContactMessageSent(false)

        this.newConversation()

        if (!this.externalLogin) {
          this.$router.push('/login')
        }
      },
      send() {
        this.sending = true

        this.createChat({
          status: 5,
          comment: this.message,
          closed: { time: new Date(), user: this.user }
        }).then(() => {
          this.createTicket()
            .then(() => {
              this.message = ''

              this.sending = false

              this.setContactMessageSent(true)
            })
            .catch(err => {
              console.error('Error on create ticket', err)

              this.message = ''

              this.sending = false

              this.setContactMessageSent(true)
            })
        })
      },
      handleKbCardCta() {
        this.showKbCard = false
      },
      async setHasTicketApp() {
        this.hasTicketApp = await this.verifyHasTicketApp()
      }
    }
  }
</script>

<style scoped>
  .kb-contact-container {
    overflow-y: auto;
    height: calc(100% - 120px);
    padding-bottom: 10px;
  }

  .octadesk-content-container {
    height: calc(100% - 69px);
  }

  .octadesk-success-container {
    padding-top: 42px;
  }

  .octadesk-content-container p {
    font-size: 14px;
    font-weight: 400;
    padding-top: 10px;
  }

  .not-avaliable-msg {
    margin: 0;
    padding: 1rem 25px;
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1.4;
  }

  .kb-contact-height {
    height: calc(100vh - 5.75rem) !important;
  }

  .sending-loader {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .sending-loader-height {
    height: 100%;
  }

  .octadesk-button__contact {
    width: 136px;
    padding: 0.6rem;
    position: absolute;
    bottom: -16px;
    left: calc(50% - 68px);
  }

  .octadesk-button__contact:disabled {
    background-color: #9cc0ef !important;
  }

  .octadesk-button__contact svg {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-40%);
    text-align: left;
  }

  .octadesk-app-contact textarea {
    border: 1px solid #ccc;
    border-radius: 10px;
    background-color: #fff;
    width: 90%;
    margin: 0 auto;
    text-align: center;
  }

  .octadesk-app-contact {
    background: #f6f6f6;
    height: 100%;
    max-height: 100%;
  }

  .octadesk-contact--card {
    background: #fff;
    margin: 0 16px;
    padding-bottom: 32px;
    margin-top: -26px;
    position: relative;
  }

  @media screen and (min-width: 800px) and (max-height: 600px) {
    .kb-card-bottom-offset {
      padding-bottom: 2.5rem;
    }
  }

  .button-close {
    font-size: 12px;
    font-weight: 400;
    color: #0062ff !important;
    border: 0px;
    cursor: pointer;
    background: transparent !important;
  }
  .button-close:hover {
    text-decoration: underline;
  }

  .hide {
    display: none;
  }
</style>
